/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, List } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';
import config from '@plone/volto/registry';

const Footer = () => {
  const { settings } = config;
  const lang = useSelector((state) => state.intl.locale);

  return (
    <>
      <div className="background-container">
        <div className="background-cell" />
      </div>
      <footer className="footer" id="footer">
        <Container>
          <List horizontal inverted>
            <div role="listitem" className="item border">
              <UniversalLink className="item" href={'/kontakt'}>
                <FormattedMessage id="Kontakt" defaultMessage="Kontakt" />
              </UniversalLink>
            </div>
            <div role="listitem" className="item border">
              <UniversalLink href={'/login'}>
                <FormattedMessage id="Intern" defaultMessage="Intern" />
              </UniversalLink>
            </div>
            <div role="listitem" className="item border">
              <UniversalLink className="item" href={'/kontakt/impressum'}>
                <FormattedMessage id="Impressum" defaultMessage="Impressum" />
              </UniversalLink>
            </div>
            <div role="listitem" className="item border">
              <UniversalLink className="item" href={'/kontakt/datenschutz'}>
                <FormattedMessage
                  id="Datenschutzerklärung"
                  defaultMessage="Datenschutzerklärung"
                />
              </UniversalLink>
            </div>
            <div role="listitem" className="item border">
              <UniversalLink
                href={settings.isMultilingual ? `/${lang}/sitemap` : '/sitemap'}
              >
                <FormattedMessage id="Übersicht" defaultMessage="Übersicht" />
              </UniversalLink>
            </div>

            <div role="listitem" className="item border">
              <p>Copyright © {new Date().getFullYear()}</p>
            </div>

            <div role="listitem" className="item border">
              <UniversalLink
                className="item"
                href={
                  settings.isMultilingual
                    ? `/${lang}/kontakt/barrierefreiheit`
                    : '/kontakt/barrierefreiheit'
                }
              >
                <FormattedMessage
                  id="Barrierefreiheit"
                  defaultMessage="Barrierefreiheit"
                />
              </UniversalLink>
            </div>
          </List>
        </Container>
      </footer>
    </>
  );
};

Footer.propTypes = {};

export default injectIntl(Footer);
